// extracted by mini-css-extract-plugin
export default {"microAppContainer":"H7aV2R8EZsz3atzyqrKQ","hidden":"Hc7NB4E2frZevfiNKpxx"};